var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgnoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66153 1.91669C7.28282 1.91669 5.35449 3.84502 5.35449 6.22373C5.35449 8.60245 7.28282 10.5308 9.66153 10.5308C12.0402 10.5308 13.9686 8.60245 13.9686 6.22373C13.9686 3.84502 12.0402 1.91669 9.66153 1.91669Z",
    fill: "url(#paint0_linear_3874_906)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0949 12.6277C10.3369 12.2773 10.1066 11.7446 9.68081 11.7451L9.28807 11.7456C9.03396 11.746 8.77985 11.7465 8.52575 11.7465C4.98586 11.7465 2.11621 14.6161 2.11621 18.156C2.11621 19.6006 3.28728 20.7717 4.73189 20.7717H9.73591C10.168 20.7717 10.4004 20.2219 10.1496 19.8701C9.41342 18.8378 8.98037 17.5744 8.98037 16.2099C8.98037 14.8796 9.39201 13.6453 10.0949 12.6277Z",
    fill: "url(#paint1_linear_3874_906)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1648 16.21C20.1648 18.9014 17.9829 21.0834 15.2914 21.0834C12.5999 21.0834 10.418 18.9014 10.418 16.21C10.418 13.5185 12.5999 11.3365 15.2914 11.3365C17.9829 11.3365 20.1648 13.5185 20.1648 16.21ZM17.5526 13.9494C17.8333 14.2301 17.8333 14.6853 17.5526 14.9659L16.647 15.8715C16.4599 16.0585 16.4599 16.362 16.647 16.5491L17.5526 17.4546C17.8333 17.7353 17.8333 18.1905 17.5526 18.4711C17.2719 18.7518 16.8168 18.7518 16.5361 18.4711L15.6305 17.5656C15.4434 17.3785 15.14 17.3785 14.9529 17.5656L14.0474 18.4711C13.7667 18.7518 13.3116 18.7518 13.0309 18.4711C12.7502 18.1905 12.7502 17.7353 13.0309 17.4546L13.9364 16.5491C14.1236 16.362 14.1236 16.0585 13.9364 15.8715L13.0309 14.9659C12.7502 14.6853 12.7502 14.2301 13.0309 13.9494C13.3116 13.6687 13.7667 13.6687 14.0474 13.9494L14.9529 14.855C15.14 15.0421 15.4434 15.0421 15.6305 14.855L16.5361 13.9494C16.8168 13.6687 17.2719 13.6687 17.5526 13.9494Z",
    fill: "url(#paint2_linear_3874_906)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3874_906",
    x1: 9.66153,
    y1: 1.91669,
    x2: 9.66153,
    y2: 10.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3874_906",
    x1: 6.18454,
    y1: 11.7451,
    x2: 6.18454,
    y2: 20.7717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3874_906",
    x1: 15.2914,
    y1: 11.3365,
    x2: 15.2914,
    y2: 21.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgnoreIcon);
export default __webpack_public_path__ + "static/media/ignore-icon.2c0383874b9b697cceb4ecc220b30b09.svg";
export { ForwardRef as ReactComponent };